import { RecipientAction } from './recipient-action';

export const menuItemList = [
    { action: RecipientAction.Edit, title: 'Edit Recipient' },
    { action: RecipientAction.ToolBox, title: 'Toolbox' },
    { action: RecipientAction.PairedDonors, title: 'View Paired Donors'},
    { action: -1, title: '' }
];